import { CompanyGenerationManager } from "./CompanyGenerationManager"

export default CompanyGenerationManager
